import React, { Component } from "react";
import { Button, Confirm, Container, Form, Grid, Input, Message, Modal, Segment } from "semantic-ui-react";
import Formsy from 'formsy-react';
import { cancelCommissionPayment, getCommissionPaymentFromRequestID, refundCommissionPayment } from "../../services/payment";
import moment from "moment";
import './CommissionPayments.less'


class CommissionPayments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requestID: '',
            error: '',
            commissionPayment: null,
            isRefundModalOpen: false,
            isCancelPaymentModalOpen: false,
            refundAmount: '',
            refundError: '',
            isSuccessMessageShown: false,
        }
    }

    onCommissionPaymentSearch = () => {
        getCommissionPaymentFromRequestID(this.state.requestID).then(res => {
            if (!res.data || res.resStatus == 400) {
                this.setState({ error: res.message, commissionPayment: null })
            } else {
                this.setState({ commissionPayment: res.data, error: '', refundError: '' })
            }
        })
    }

    onRefundModalOpen = () => {
        this.setState({ isRefundModalOpen: true, refundAmount: this.state.commissionPayment.amount });
    }

    onPaymentCancel = () => {
        cancelCommissionPayment({ commissionPaymentID: this.state.commissionPayment.scPaymentID }).then(res => {
            if (res.resStatus == 200) {
                this.setState({
                    isCancelPaymentModalOpen: false,
                    requestID: '',
                    error: '',
                    commissionPayment: null
                })
                this.showSuccessMessage();
            }
        })
    }

    onPaymentRefund = () => {
        refundCommissionPayment({ commissionPaymentID: this.state.commissionPayment.scPaymentID, amount: Number(this.state.refundAmount) })
            .then(res => {
                if (res.resStatus != 200) {
                    this.setState({ refundError: res.message })
                }
                else {
                    this.setState({
                        refundError: '',
                        isRefundModalOpen: false,
                        requestID: '',
                        error: '',
                        commissionPayment: null
                    })
                    this.showSuccessMessage();
                }
            })
    }

    showSuccessMessage = () => {
        this.setState({ isSuccessMessageShown: true });
        setTimeout(() => {
            this.setState({ isSuccessMessageShown: false });
        }, 4000);
    }

    render() {
        const { commissionPayment, isCancelPaymentModalOpen, isRefundModalOpen } = this.state;
        return <div class="search-requests">
            <Container fluid className="commision-paymant-container">
                <Segment very padded>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <h3>Search Commission Payment By Request ID</h3>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Formsy onValidSubmit={this.onCommissionPaymentSearch}>
                                    <Form.Field inline>
                                        <label className="commision-paymant-form-label">Request ID: </label>
                                        <Input value={this.state.requestID} onChange={(e, data) => this.setState({ requestID: data.value })}
                                            required name='requestID' placeholder='Enter request ID' type='number' />
                                        <Button type='submit'>Get Commission Payment</Button>
                                    </Form.Field>
                                </Formsy>
                            </Grid.Column>
                        </Grid.Row>
                        {this.state.error ?
                            <Grid.Row>
                                <Grid.Column width={16}><Message negative>
                                    <p>{this.state.error}</p>
                                </Message>  </Grid.Column>
                            </Grid.Row> : ''}
                        {this.state.isSuccessMessageShown ?
                            <Grid.Row>
                                <Grid.Column width={16}><Message positive>
                                    <p>Updated Commission Payment Successfully!</p>
                                </Message>  </Grid.Column>
                            </Grid.Row> : ''}
                    </Grid>
                </Segment>
                {commissionPayment ? <Segment>
                    <Grid padded={true}>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <h3>Commission Payment</h3>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <h3>Seller Name</h3>
                                <p>{commissionPayment.sellerName}</p>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <h3>Acceptance Code</h3>
                                <p>{commissionPayment.acceptanceCode}</p>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <h3>Amount</h3>
                                <p>$ {commissionPayment.amount}</p>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <h3>Paid On</h3>
                                <p>{moment(commissionPayment.paidOn).format('LL')}</p>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <h3>Status</h3>
                                <p>{commissionPayment.paymentStatus}</p>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                {commissionPayment.paymentStatus == 'Completed' ?
                                    <Button onClick={this.onRefundModalOpen} primary> Refund Commission Payment </Button> :
                                    commissionPayment.paymentStatus == 'Failed' || commissionPayment.paymentStatus == 'Action Required' ?
                                        <Button onClick={() => this.setState({ isCancelPaymentModalOpen: true })} primary> Cancel Commission Payment </Button>
                                        : ''}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment> : ''}
            </Container>
            <Modal
                open={isRefundModalOpen}
                onClose={() => this.setState({ isRefundModalOpen: false })}
            >
                <Modal.Header>Refund Commission Payment</Modal.Header>
                <Modal.Content>
                    <label>Refund Amount: </label>
                    <Input value={this.state.refundAmount} onChange={(e, data) => this.setState({ refundAmount: data.value })}
                        required name='Refund Amount' placeholder='Enter Refund Amount' type='number' />
                    {this.state.refundError ?
                        <Message negative>
                            <p>{this.state.refundError}</p>
                        </Message>
                        : ''}
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => this.setState({ isRefundModalOpen: false })}>
                        Close
                    </Button>
                    <Button
                        content='Submit'
                        positive
                        onClick={this.onPaymentRefund}
                        disabled={!this.state.refundAmount}
                    />
                </Modal.Actions>
            </Modal>
            <Confirm
                open={isCancelPaymentModalOpen}
                onClose={() => this.setState({ isCancelPaymentModalOpen: false })}
                header='Cancel Commission Payment'
                content='Are you sure you want to cancel Commission Payment?'
                onCancel={() => this.setState({ isCancelPaymentModalOpen: false })}
                onConfirm={this.onPaymentCancel}
            />
        </div>
    }
}

export default CommissionPayments